import { useStore } from 'state/store'

export type WorkspaceChangeProps = {
  workspaceId: string
  organizationId: string
}

export const useWorkspaceChange = () => {
  const attachedOrganizations = useStore(state => state.attachedOrganizations)
  const setOrganization = useStore(state => state.setOrganization)
  const setRequestedWorkspaceId = useStore(
    state => state.setRequestedWorkspaceId
  )

  const onWorkspaceChange = ({
    workspaceId,
    organizationId,
  }: WorkspaceChangeProps) => {
    const newOrganization = attachedOrganizations.find(
      organization => organization.id === organizationId
    )
    if (newOrganization) {
      setOrganization(newOrganization)
    }
    setRequestedWorkspaceId(workspaceId)
  }

  return onWorkspaceChange
}
